<template>
<v-container>
    <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>
    <v-row v-if="bPoint.mobile">
      <v-card-text>
      <v-expansion-panels flat accordion v-model="panel" tile>
        <v-expansion-panel >
          <v-expansion-panel-header class="clearExpansinHeaderPadding">{{getTranslation("Filters")}}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col class="clearColumnPadding my-2">
              <v-row class="justify-start">
            <v-col cols="11"
        class="form-builder-input ml-3 pl-1">
            <VSelectAll
              v-model="selectedVehicleGroups"
              :items="select.vehicleGroups"
              :label="getTranslation('Vehicle groups')"
            ></VSelectAll>
            </v-col>
            <v-col cols="11"
        class="form-builder-input ml-3  pl-1">
            <v-autocomplete
              class="font-weight-light"
              color="primary"
              outlined
              dense
              hide-details="auto"
              v-model="searchObject.vehicleIds"
              :items="select.vehicles"
              :label="getTranslation('Vehicles')"
              multiple
            ></v-autocomplete>
            </v-col>
            <v-col cols="11"
        class="form-builder-input ml-3 pl-1">
            <VSelectAll
              v-model="searchObject.serviceTypes"
              :items="select.servicetypes"
              :label="getTranslation('Service type')"
            ></VSelectAll>
            </v-col>
            <v-col cols="12" class="form-builder-input pb-0">
              <v-checkbox
                v-model="searchObject.showInactive"
                class="mx-2 mt-3 pb-0 mb-0"
                :label="getTranslation('Show inactive')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12"
            class="form-builder-input pb-0">
            <span>
                <v-btn
                small
                color="primary"
                @click="search"
                class="mt-0 mr-3 white--text float-right" 
              > {{getTranslation('search')}}
              </v-btn>
            </span>
            </v-col>
            </v-row>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    </v-row>
    <v-row>
      <v-col  lg="9" xl="10">
        <v-row no-gutters id="serviceRealizationBar" class="pb-3">
        <v-col cols="1" id="headerSlot">
          <v-btn
                  block
                  small
                  color="primary"
                  class="white--text font-weight-light mt-2"
                  @click="openAddDialog"
                  >{{ getTranslation('Add new item') }}</v-btn
                >
        </v-col>
        </v-row>
        <v-data-table
          dense
          :headers="headers"
          :items="items"
          class="elevation-3"
          multi-sort
          id="genTable"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15]
          }"
        >
          <template v-slot:header.crud="{ header }">
            Action
          </template>
          <template v-slot:item.isActive="{ item }">
            <v-icon v-if="item.isActive == true" color="blue lighten-2"
              >mdi-check</v-icon
            >
            <v-icon v-else color="red">mdi-close</v-icon>
          </template>
          <template v-slot:item.crud="{ item }">
            <div v-if="item.isRealized == true && item.isActive == true">
                <v-icon dense @click="openUpdateDialog(item)" class="mr-2" >mdi-pencil</v-icon>
                <v-icon dense @click="openDeleteDialog(item.id)" class="mr-2"> mdi-delete</v-icon>
            </div>
            <div v-else-if="item.isActive == true">
                <v-icon dense @click="openFinishDialog(item)">done</v-icon>
            </div>
          </template>
        </v-data-table>
      </v-col>
      <v-col v-if="!bPoint.mobile" lg="3" xl="2" class="text-center pt-10" 
      style="padding-bottom:0px">
        <v-card>
          <v-card-title  class="ml-2 pt-3 caption font-weight-bold mt-5">
              {{getTranslation("Filters")}}
          </v-card-title>
        <v-card-text class="pb-3">
          <v-row class="justify-start">
            <v-col cols="11"
        class="form-builder-input ml-3 pl-1">
            <VSelectAll
              v-model="selectedVehicleGroups"
              :items="select.vehicleGroups"
              :label="getTranslation('Vehicle groups')"
            ></VSelectAll>
            </v-col>
            <v-col cols="11"
        class="form-builder-input ml-3  pl-1">
            <v-autocomplete
              class="font-weight-light"
              color="primary"
              outlined
              dense
              hide-details="auto"
              v-model="searchObject.vehicleIds"
              :items="select.vehicles"
              :label="getTranslation('Vehicles')"
              multiple
            ></v-autocomplete>
            </v-col>
            <v-col cols="11"
        class="form-builder-input ml-3 pl-1">
            <VSelectAll
              v-model="searchObject.serviceTypes"
              :items="select.servicetypes"
              :label="getTranslation('Service type')"
            ></VSelectAll>
            </v-col>
            <v-col cols="12" class="form-builder-input pb-0">
              <v-checkbox
                v-model="searchObject.showInactive"
                class="mx-2 mt-3 pb-0 mb-0"
                :label="getTranslation('Show inactive')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12"
            class="form-builder-input pb-0">
            <span>
                <v-btn
                small
                color="primary"
                @click="search"
                class="mt-0 mr-3 white--text float-right" 
              > {{getTranslation('search')}}
              </v-btn>
            </span>
            </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <template>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        :fullscreen="$vuetify.breakpoint.mobile"
        :retain-focus="false"
        persistent
      >
        <ServiceRealizationDialog
          @close="onExit"
          :dataObject="dataObject"
          :isUpdate="isUpdate"
          :title="title"
          :method="method"
          :endPoint="endPoint"
          @snackbarMessage="handleSnackbarMessage"
        >
        </ServiceRealizationDialog>
      </v-dialog>
      <v-dialog
        v-model="dialogDelete"
        persistent
        max-width="400px"
        :retain-focus="false"
      >
        <base-dialog-confirmation
          @close="onDeleteClose"
          @submit="onDeleteEvent"
        >
          <h4>{{ deleteServiceTitle }}</h4>
        </base-dialog-confirmation>
      </v-dialog>
      <v-snackbar color="green" dark v-model="snackbar">
        <v-card-text> {{snackbarMessage}} </v-card-text>
      </v-snackbar>
    </template>
    </v-row>
</v-container>
</template>
<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import httpClient from '@/api/httpClient'
import store from '@/store/store'
import ServiceRealizationDialog from '@/views/serviceBook/ServiceRealizationDialog'
import BaseDialogConfirmation from '@/components/BaseDialogConfirmation'
import { integer } from 'vee-validate/dist/rules'
import VDateTextBox from '@/components/custom/VDateTextBox'
import formatDate from '@/utils/formatDateHelper.js'
import navigationMixin from '../../components/v2/navigationMixin'
import VSelectAll from '../../components/custom/VSelectAll'

export default {
  data() {
    return {
      panel: 0,
      snackbar: false,
      snackbarMessage: '',
      filterDrawer: false,
      title: '',
      startDateMenu: false,
      endDateMenu: false,
      selectedVehicleGroups: [],
      queryString: '',
      endPoint: 'plannedServices',
      vehicles: [],
      select: {
        vehicleGroups: [],
        vehicles: [],
        servicetypes: []
      },
      searchObject: {
        vehicleIds: [],
        startDate: null,
        endDate: null,
        showInactive: false
      },
      deleteIdentifier: integer,
      dataObject: integer,
      dialog: false,
      dialogDelete: false,
      isUpdate: false,
      method: null,
      headers: [
        {
          text: this.getTranslation('Service type'),
          value: 'serviceType'
        },
        {
          text: this.getTranslation('Name'),
          value: 'name'
        },
        {
          text: this.getTranslation('Registration Mark'),
          value: 'registrationPlate'
        },
        {
          text: this.getTranslation('Planned'),
          value: 'occursAt'
        },
        {
          text: this.getTranslation('Realized date'),
          value: 'realizedDate'
        },
        {
          text: this.getTranslation('Active'),
          value: 'isActive'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'crud'
        }
      ],
      items: [],
      itemsForNavigation: [
        {
          text: translate('Service book', 'navigation.serviceBook'),
          disabled: true
        },
        {
          text: translate('Due services', 'navigation.serviceBook'),
          disabled: true
        }
      ]
    }
  },
  components: {
    ServiceRealizationDialog,
    BaseDialogConfirmation,
    VDateTextBox,
    BaseTooltip: () => import('@/components/BaseTooltip')
  },
  mounted() {
    this.getItems()
    httpClient.get('lookup/vehiclegroups').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.id
        }
        this.select.vehicleGroups.push(obj)
      }
    })
    httpClient.get('vehicles').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.name,
          vehicleGroupIds: data.vehicleGroupIds
        }
        this.select.vehicles.push(obj)
        this.vehicles.push(obj)
      }
    })
    this.getServiceTypeSelect()
  },
  methods: {
    getAppropriateTitle() {},
    onDeleteClose() {
      this.dialogDelete = false
    },
    handleSnackbarMessage(message) {
      this.snackbarMessage = message
      this.snackbar = true
      setTimeout(function() {
        this.snackbar = false
      }, 2500)
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'pages.serviceRealization')
    },
    setBeginDate(value) {
      this.searchObject.startDate = value
    },
    setEndDate(value) {
      this.searchObject.endDate = value
    },
    onExit() {
      if (!this.dialog) {
        return
      }
      this.dialog = false
      this.dataObject = {}
      this.getItems()
    },
    getServiceTypeSelect() {
      httpClient.get('servicetypes').then(response => {
        for (const data of response.data) {
          let obj = {
            text: data.name,
            value: data.id
          }
          this.select.servicetypes.push(obj)
        }
      })
    },
    openUpdateDialog(value) {
      this.dataObject = value
      this.title = translate('Update realized service', 'pages.serviceSchedules')
      this.isUpdate = true
      this.dialog = true
      this.method = 'PUT'
    },
    openFinishDialog(value) {
      this.dataObject = value
      this.title = translate('Finish planned service', 'pages.serviceSchedules')
      this.isUpdate = false
      this.dialog = true
      this.method = 'POST'
    },
    openAddDialog() {
      this.dataObject = {
        id: null,
        isRealized: false
      }
      this.title = translate('Add realized service', 'pages.serviceRealization')
      this.isUpdate = false
      this.dialog = true
      this.method = 'POST'
    },
    openDeleteDialog(value) {
      this.dialogDelete = true
      this.deleteIdentifier = value
    },
    async onDeleteEvent() {
      await httpClient.delete(`/plannedServices/${this.deleteIdentifier}`)

      this.getItems()
    },
    buildQuery() {
      let firstAppend = true
      if (this.searchObject.vehicleIds.length > 0) {
        for (let id of this.searchObject.vehicleIds) {
          firstAppend = this.appendQuestionMark(firstAppend)
          this.queryString += 'RegistrationMarks=' + id + '&'
        }
      }
      if (this.searchObject.startDate != null) {
        firstAppend = this.appendQuestionMark(firstAppend)
        this.queryString += 'startDate=' + this.searchObject.startDate + '&'
      }
      if (this.searchObject.endDate != null) {
        firstAppend = this.appendQuestionMark(firstAppend)
        this.queryString += 'endDate=' + this.searchObject.endDate + '&'
      }
      if (this.searchObject.serviceTypes != null) {
        for (let id of this.searchObject.serviceTypes) {
          firstAppend = this.appendQuestionMark(firstAppend)
          this.queryString += 'ServiceTypes=' + id + '&'
        }
      }
      firstAppend = this.appendQuestionMark(firstAppend)
      this.queryString += 'showInactive=' + this.searchObject.showInactive + '&'
    },
    getItems() {
      this.items = []
      httpClient.get(this.fullPath).then(response => {
        let data = this.adaptDates(response.data)
        this.items = data
      })
    },
    search() {
      this.resetSearchQuery()
      this.buildQuery()
      this.getItems()
    },
    appendQuestionMark(value) {
      if (value == true) {
        this.queryString += '?'
        return false
      }
    },
    adaptDates(items) {
      for (let item of items) {
        if (item.plannedDate != null) {
          item.plannedDate = formatDate(item.plannedDate, 'short')
        }
        if (item.realizedDate != null) {
          item.realizedDate = formatDate(item.realizedDate, 'short')
        }
      }
      return items
    },
    resetSearchQuery() {
      this.queryString = ''
    },
    adaptTextForDropDown(text) {
      let adaptedText = ''
      for (let letter in text) {
        if (letter == 0) {
          adaptedText += text[letter].toUpperCase()
        } else if (text[letter] == text[letter].toUpperCase()) {
          adaptedText += text[letter].toLowerCase()
        } else {
          adaptedText += text[letter]
        }
      }
      return adaptedText
    }
  },
  computed: {
    fullPath() {
      return this.endPoint + this.queryString
    },
    bPoint() {
      return this.$vuetify.breakpoint
    },
    deleteServiceTitle() {
      return translate('Do you want to delete this item ?', 'notification')
    }
  },
  watch: {
    selectedVehicleGroups: {
      handler() {
        if (this.selectedVehicleGroups.length == 0) {
          this.select.vehicles = this.vehicles
        } else {
          this.select.vehicles = []
          for (let vehicle of this.vehicles) {
            for (let groupId of vehicle.vehicleGroupIds) {
              for (let group of this.selectedVehicleGroups) {
                if (group == groupId) {
                  this.select.vehicles.push(vehicle)
                }
              }
            }
          }
        }
      }
    },
    items: {
      handler() {
        this.items.forEach(element => {
          element['serviceType'] = this.getTranslation(
            this.adaptTextForDropDown(element['serviceType'])
          )
        })
      }
    }
  }
}
</script>
<style scoped>
#genTable >>> thead > tr > th {
  background-color: var(--primary-color);
  color: white;
}
#headerSlot {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
